<template>
  <div class="main">
    <Header
      :show="true"
      title="过磅检测"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div class="content">
      <van-cell-group>
        <van-cell
          :value="rangeQueryDate"
          is-link
          title="时间区间"
          @click="listQuery.showCalendar = true"
        />
        <van-calendar
          v-model="listQuery.showCalendar"
          type="range"
          :max-range="366"
          :min-date="new Date(2020, 1, 1)"
          :max-date="new Date(2030, 12, 31)"
          :default-date="listQuery.data.date"
          @confirm="onDateQueryChoose"
        />
        <van-cell
          :value="statusQueryName"
          is-link
          title="检测状态"
          @click="listQuery.showStatusActionSheet = true"
        />
        <van-action-sheet
          v-model="listQuery.showStatusActionSheet"
          :actions="listQuery.statusList"
          cancel-text="取消"
          description="请选择待查询的检测状态"
          @select="onStatusQueryChoose"
        />
      </van-cell-group>
      <div style="padding: 16px">
        <van-button
          round
          block
          type="info"
          :loading="table.loading"
          @click="handleQuery"
        >
          查询
        </van-button>
      </div>
      <el-table
        ref="table"
        :loading="table.loading"
        :data="table.data"
        style="width: 100%"
        row-key="serialNum"
        :row-class-name="handleRowClassName"
        @row-click="onTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-form
              label-position="left"
              label-width="100px"
              class="table-expand-form"
            >
              <el-form-item label="流水号">
                <span>{{ row.serialNum }}</span>
              </el-form-item>
              <el-form-item label="车牌号">
                <span>{{ row.plateNumber }}</span>
              </el-form-item>
              <el-form-item label="供应商">
                <span>{{ row.supplier }}</span>
              </el-form-item>
              <el-form-item label="物料类型">
                <span>{{ row.materialType }}</span>
              </el-form-item>
              <el-form-item label="物料名称">
                <span>{{ row.materialName }}</span>
              </el-form-item>
              <el-form-item label="毛重">
                <span>{{ row.grossWeight }}吨</span>
              </el-form-item>
              <el-form-item label="识别照片">
                <van-image
                  width="166px"
                  height="100px"
                  :src="row.aiImgUrl"
                  @click="handleClickPreview(row.aiImgUrl)"
                >
                  <template #index>
                    识别照片
                  </template>
                </van-image>
              </el-form-item>
              <el-form-item
                v-if="row.brief"
                label="识别物料"
              >
                <span>{{ row.brief }}</span>
              </el-form-item>
              <el-form-item label="含水量">
                <span>{{ row.waterPercent }}%</span>
              </el-form-item>
              <el-form-item label="品质">
                <span>{{ row.quality }}级</span>
              </el-form-item>
              <el-form-item label="检测照片">
                <van-image
                  width="166px"
                  height="100px"
                  :src="row.qcPhotoUrl"
                  @click="handleClickPreview(row.qcPhotoUrl)"
                >
                  <template #index>
                    检测照片
                  </template>
                </van-image>
              </el-form-item>
              <el-form-item label="备注">
                <span>{{ row.remark }}</span>
              </el-form-item>
              <el-form-item label="检测结果">
                <template #default>
                  <el-tag
                    v-if="row.detectStatus !== 2"
                    type="info"
                  >
                    未完成检测
                  </el-tag>
                  <el-tag
                    v-else-if="row.busStatus === 1"
                    type="success"
                  >
                    已通过
                  </el-tag>
                  <el-tag
                    v-else
                    type="danger"
                  >
                    未通过
                  </el-tag>
                </template>
              </el-form-item>
              <el-form-item label="状态">
                <el-tag
                  v-if="row.detectStatus == 1"
                  type="danger"
                >
                  检测中
                </el-tag>
                <el-tag
                  v-else-if="row.detectStatus == 2"
                  type="success"
                >
                  检测完成
                </el-tag>
                <el-tag
                  v-else
                  type="primary"
                >
                  未知
                </el-tag>
              </el-form-item>

              <el-form-item
                v-if="checkPermission([492])"
                label="操作"
              >
                <el-button
                  v-if="row.detectStatus !== 2"
                  type="primary"
                  size="mini"
                  @click="handleClickUpdate(row)"
                >
                  检测
                </el-button>
                <el-button
                  v-else
                  type="info"
                  size="mini"
                  disabled
                >
                  检测
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          type="index"
          align="center"
          width="60"
        />
        <el-table-column
          label="车牌号"
          props="plateNumber"
          align="center"
          width="120"
        >
          <template slot-scope="{ row }">
            {{ row.plateNumber }}
          </template>
        </el-table-column>
        <el-table-column
          label="供应商"
          props="supplier"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.supplier }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          prop="detectStatus"
          align="center"
          width="90"
        >
          <template slot-scope="{ row }">
            <el-tag
              v-if="row.detectStatus === 0"
              type="primary"
            >
              待检测
            </el-tag>
            <el-tag
              v-else-if="row.detectStatus === 1"
              type="warning"
            >
              检测中
            </el-tag>
            <el-tag
              v-else-if="row.detectStatus === 2"
              type="success"
            >
              检测完成
            </el-tag>
            <el-tag
              v-else
              type="danger"
            >
              未知
            </el-tag>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total > 0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        style="margin: 0.6rem 0; text-align: center"
        @current-change="handleQuery"
      />
    </div>
    <Footer value="service" />
  </div>
</template>
<script>
import dayjs from "dayjs";

import { ImagePreview } from "vant";
import checkPermission from "@/utils/permission";

import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { getList } from "@/api/owdr";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      listQuery: {
        limit: 10,
        page: 1,
        showCalendar: false,
        data: {
          date: [dayjs().add(-1, "week").toDate(), dayjs().toDate()],
          detectStatus: "",
        },
        showStatusActionSheet: false,
        statusList: [
          { name: "全部", value: "" },
          { name: "待检测", value: 0 },
          { name: "检测中", value: 1 },
          { name: "检测完成", value: 2 },
        ],
      },
      table: {
        loading: false,
        key: "owdr_table",
        total: 0,
        data: [],
      },
    };
  },
  computed: {
    rangeQueryDate() {
      const { date } = this.listQuery.data;
      return `${dayjs(date[0]).format("YYYY-MM-DD")} - ${dayjs(date[1]).format(
        "YYYY-MM-DD"
      )}`;
    },
    statusQueryName() {
      const {
        data: { detectStatus },
        statusList,
      } = this.listQuery;

      return statusList.find((st) => st.value === detectStatus)?.name;
    },
  },
  created() {
    this.handleQuery();
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    handleQuery() {
      const { limit, page, data } = this.listQuery;
      const payload = { ...data, limit, page };
      this.table.loading = true;
      getList(payload)
        .then(({ data }) => {
          const {
            page: { total, records },
          } = data;

          this.table.data = records;
          this.table.total = total;
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    onDateQueryChoose(val) {
      this.listQuery.data.date = val;
      this.listQuery.showCalendar = false;
    },
    onStatusQueryChoose(val) {
      this.listQuery.data.detectStatus = val.value;
      this.listQuery.showStatusActionSheet = false;
      this.handleQuery();
    },
    onTableRowClick(row) {
      this.$refs.table.toggleRowExpansion(row);
    },
    handleClickPreview(url) {
      console.log(url);
      let urlArr = [];
      urlArr.push(url);
      ImagePreview(urlArr);
    },
    handleRowClassName({ row }) {
      if (row.detectStatus !== 2 && row.sameStatus === 0) {
        return "fault-row";
      }
      return "";
    },
    handleClickUpdate(row) {
      this.$router.push({
        path: "/service/business/owdr/create",
        query: row,
      });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .van-cell__title {
  max-width: 30%;
  font-size: 2vh;
}
::v-deep .van-cell__value {
  max-width: 70%;
}
.content {
  padding-bottom: 80px;
}
.table-expand-form {
  padding: 0 12px;

  .el-form-item {
    margin: 4px 0px;
  }
}

::v-deep .el-table .fault-row {
  background: #fde2e2;
  // background: #feebe9;
}
</style>
